import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Footer } from '../components/Footer/Footer';
import { routes } from '../constants/constants';
import { useLocation } from '../react-router-hooks';

const Button = styled.button`
  padding: 12px 16px;
  font-family: Heebo, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  background-color: #0e1528;
  border-radius: 4px;
  height: 40px;
  color: ${(props: any) => props.theme.white};
  border: none;
  cursor: pointer;

  :hover {
    background-color: #1b2a50;
  }

  :disabled {
    background-color: #dddee0;
    cursor: auto;
  }
`;

export const ErrorScreen = () => {
  const { t } = useTranslation();

  const { navigate } = useLocation();

  return (
    <div className="newPageRoot">
      <div className="newPageWrapper">
        <div className="newPageHeaderLogos">
          <img
            style={{ height: 50 }}
            src={require('../assets/nect-logo-black.svg')}
            alt="Nect"
          />
        </div>

        <h1 className="newPageHeaderTitle">{t('Something went wrong')}</h1>

        <p className="newPageHeaderSubtitle">{t('Have a question?')}</p>

        <div style={{ padding: '24px' }}>
          <Button
            onClick={() => {
              navigate(routes.HOME);
            }}
          >
            {t('Help Centre')}
          </Button>
        </div>
      </div>

      <Footer />
    </div>
  );
};
